import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DROPZONE_CONFIG, DropzoneConfigInterface, DropzoneModule } from 'ngx-dropzone-wrapper';

import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { PhotoUploadEffects } from './+state/photo-upload.effects';
import { PHOTOUPLOAD_FEATURE_KEY, photoUploadReducer } from './+state/photo-upload.reducer';
import { ClaimPhotoListComponent } from './components/claim-photo-list/claim-photo-list.component';
import { ClaimPhotoComponent } from './components/claim-photo/claim-photo.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UiKitModule,
    DropzoneModule,
    SharedServicesModule,
    StoreModule.forFeature(PHOTOUPLOAD_FEATURE_KEY, photoUploadReducer),
    EffectsModule.forFeature([PhotoUploadEffects])
  ],
  declarations: [ClaimPhotoComponent, ClaimPhotoListComponent],
  exports: []
})
export class ClaimPhotoUploadFeatureModule {
  static forRoot(
    dropzoneConfig: DropzoneConfigInterface
  ): ModuleWithProviders<ClaimPhotoUploadFeatureModule> {
    return {
      ngModule: ClaimPhotoUploadFeatureModule,
      providers: [
        {
          provide: DROPZONE_CONFIG,
          useValue: dropzoneConfig
        }
      ]
    };
  }
}
